/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/

import React, { useState, useEffect } from 'react';

interface HiddenStateSelectorProps {
  initialState: string;
  states: string[];
  onSave: (newState: string) => void;
}

const HiddenStateSelector: React.FC<HiddenStateSelectorProps> = ({
  initialState,
  states,
  onSave
}) => {
  const [stateIndex, setStateIndex] = useState<number>(0);

  // Effect to sync internal state with external initialValue changes
  useEffect(() => {
    const index = states.indexOf(initialState);
    if (index !== -1) {
      setStateIndex(index);
    }
  }, [initialState, states]);
  
  const handleClick = () => {
    let newStateIndex = stateIndex + 1;
    if (newStateIndex >= states.length) {
      newStateIndex = 0;
    }
    const newState = states[newStateIndex];
    onSave(newState);
    console.log("state set to:" + newState);
    setStateIndex(newStateIndex);
  };

  return (
    <span className='hidden-field' onClick={handleClick}>
      {states[stateIndex]}
    </span>
  );
};

export default HiddenStateSelector;
